import register from '../../../../global/js/registry';
export default register('m-fhw-contact-form', () => import(/* webpackMode: "lazy" */ './m-fhw-contact-form.controller'));
